import * as types from '../../../constants/actionTypes';
import objectAssign from 'object-assign';
const initialState = {
	adminUserData: {},
	userListData: [],
	userData: {},
	adminUserUpdatedData: {},
	emailTemplates: [],
	pages: [],
	logs: [],
	feedbacks: [],
	changedSpecialistType: true
};

export default function userReducer(state = initialState, action) {
	switch (action.type) {
		case types.GET_LOGS_LIST:
			return {
				...state,
				logs: action.logs
			};
		case types.ADD_USER:
			return {
				...state,
				adminUserData: action.adminUserData
			};
		case types.GET_USER_LIST:
			return {
				...state,
				userListData: action.userListData
			};
		case types.GET_USER_BY_ID:
			return {
				...state,
				userData: action.userData
			};
		case types.UPDATE_USER:
			return {
				...state,
				adminUserUpdatedData: action.adminUserUpdatedData
			};
		case types.GET_EMAIL_TEMPLATES:
			return {
				...state,
				emailTemplates: action.emailTemplates
			};
		case types.GET_EMAIL_TEMPLATE_BY_ID:
			return {
				...state,
				emailTemplates: action.emailTemplates
			};
		case types.GET_PAGES_LIST:
			return {
				...state,
				pages: action.pages
			};
		case types.GET_PAGE_BY_ID:
			return {
				...state,
				pages: action.pages
			};
		case types.ADD_EDIT_PAGE:
			return {
				...state,
				pages: action.pages
			};
		case types.GET_FEEDBACKS_LIST:
			return {
				...state,
				feedbacks: action.feedbacks
			};
		case types.UNSUBSCRIBE_EMAILS_VIA_PROFILE:
			return {
				...state,
				unsubscribe: action.data
			};
		case types.GET_PAYMENT_CONFIG:
			return {
				...state,
				paymentConfigData: action.paymentConfigData
			};
		case types.CHANGE_SPECIALIST_TYPE:
			return {
				...state,
				changedSpecialistType: action.data
			};
		case types.CHANGE_FEEDBACK_TYPE:
			return {
				...state,
				changedFeedbackType: action.data
			};
		case types.CHANGE_SEARCHED_DATE:
			return {
				...state,
			changeSearchedDate: action.data
			};
		default:
			return state;
	}
}

